<div
  #panel
  class="floating-panel"
  [ngClass]="{ minimized: isPanelMinimized }"
  [style.zIndex]="zIndex"
  *ngIf="panelVisible"
  (click)="bringToFront()"
>
  <div #header class="panel-header" (mousedown)="onHeaderMouseDown($event)">
    <div class="panel-title">{{ title }}</div>

    <div class="panel-controls">
      <button
        class="control-button minimize-button"
        (click)="toggleMinimize()"
        [attr.title]="isPanelMinimized ? 'Expand' : 'Minimize'"
      >
        <span>{{ isPanelMinimized ? '&#9650;' : '&#9660;' }}</span>
      </button>
      <button class="control-button close-button" (click)="closePanel()" title="Close">
        <span>&#10005;</span>
      </button>
    </div>
  </div>

  <div
    #content
    class="panel-content"
    [style.display]="isPanelMinimized ? 'none' : 'block'"
    [style.width]="width"
    [style.height]="height"
    [style.min-width]="minWidth"
    [style.min-height]="minHeight"
  >
    <ng-content></ng-content>
  </div>
</div>
